<template>

  <month-base-bar>
    <v-icon icon="$calendarEvent" :color="VerticalRegistry.get('event')?.color ?? '#787878'" />
    {{ item.spacesSold }}/{{ item.spacesTotal}} – {{ item.eventName }}
  </month-base-bar>

</template>

<script setup lang="ts">

import MonthBaseBar from './MonthBaseBar.vue'
import type { MonthEventInventoryCalendarItem } from '../../calendarItemTypes'
import VerticalRegistry from '../../../../../../verticals/VerticalRegistry'

/**
 * Props
 */

interface Props {
  item: MonthEventInventoryCalendarItem
}

defineProps<Props>()

</script>
